export default __webpack_public_path__ + "8aaea411eef0655d0d00024d37690ae8.png";